import { combineReducers } from 'redux';

import { GenericAction, genericReducer, GenericState } from 'services/genericAPIGatewayService';
import { Action as EditorAction, reducer as editorReducer, State as EditorState } from './editor';

import { Campaign, Ruleset } from 'entities/campaign';
import { IP } from 'entities/ip';
import { RulesetSplitTest } from 'entities/rulesetSplitTest';
import { SplitTest } from 'entities/splitTest';

import { Sagas as CampaignsSagas } from './campaigns';
import { CloneCampaignAction, watchForClone } from './cloneCampaign';
import { Sagas as EditorSagas } from './editor';
import { Sagas as GlobalIPWhitelistSagas } from './globalIpWhitelist';
import { Sagas as IPWhitelistSagas } from './ipWhitelist';
import { Action as RulesetsAction, rulesetReducer, Sagas as RulesetsSagas } from './rulesets';
import { Sagas as RulesetSplitTestsSagas } from './rulesetSplitTests';
import { Sagas as SplitTestsSagas } from './splitTests';

import { Service } from './services';
export { Service };

export type Action =
  | GenericAction<Campaign, Service.Campaigns>
  | EditorAction
  | RulesetsAction
  | GenericAction<RulesetSplitTest, Service.RulesetSplitTests>
  | GenericAction<IP, Service.IpWhitelist>
  | GenericAction<RulesetSplitTest, Service.RulesetSplitTests>
  | GenericAction<SplitTest, Service.SplitTests>
  | CloneCampaignAction;

export interface State {
  campaigns: GenericState<Campaign>;
  editor: EditorState;
  rulesets: GenericState<Ruleset>;
  rulesetSplitTests: GenericState<RulesetSplitTest>;
  ipWhitelist: GenericState<IP>;
  splitTests: GenericState<SplitTest>;
  globalIpWhitelist: GenericState<IP>;
}

export const reducer = combineReducers<State>({
  campaigns: genericReducer<Campaign, Service.Campaigns>(Service.Campaigns),
  editor: editorReducer,
  rulesets: rulesetReducer(genericReducer<Ruleset, Service.Rulesets>(Service.Rulesets)),
  rulesetSplitTests: genericReducer<RulesetSplitTest, Service.RulesetSplitTests>(Service.RulesetSplitTests),
  ipWhitelist: genericReducer<IP, Service.IpWhitelist>(Service.IpWhitelist),
  splitTests: genericReducer<SplitTest, Service.SplitTests>(Service.SplitTests),
  globalIpWhitelist: genericReducer<IP, Service.GlobalIpWhitelist>(Service.GlobalIpWhitelist),
});

export const Sagas = [
  ...CampaignsSagas,
  ...EditorSagas,
  ...RulesetsSagas,
  ...IPWhitelistSagas,
  ...RulesetSplitTestsSagas,
  ...SplitTestsSagas,
  ...GlobalIPWhitelistSagas,
  watchForClone(),
];
